module.exports = __webpack_public_path__ + "img/4_ar.16e3c7a9.png";